import { TMBoardId, TMChangeOrderBoardResponse } from '@business/entities/tm/TMChangeOrderBoardResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { TimeMaterialsFilterData } from '@modules/timeMaterials/TimeMaterialsPage/TimeMaterialsPage';
import { TimeMaterialBoardResponse } from '@business/entities/tm/TimeMaterialBoardResponse';

export function fetchTimeMaterialBoards(permission = true) {
  return Endpoint.get<TMChangeOrderBoardResponse[]>(`@gc/tm-change-order-board`, { params: { permission } });
}

export function fetchTimeMaterialBoard(id: TMBoardId, data?: Partial<TimeMaterialsFilterData>) {
  const params = R.objectCompact(data);
  return Endpoint.get<TMChangeOrderBoardResponse>(`@gc/tm-change-order-board/board/${id}`, { params });
}

export function createTimeMaterialBoard(data: Partial<TMChangeOrderBoardResponse> | Partial<TimeMaterialBoardResponse>) {
  return Endpoint.post<TMChangeOrderBoardResponse>(`@gc/tm-change-order-board`, { data });
}

export function updateTimeMaterialBoard(id: string, data: Partial<TMChangeOrderBoardResponse> | Partial<TimeMaterialBoardResponse>) {
  return Endpoint.patch<TMChangeOrderBoardResponse>(`@gc/tm-change-order-board/${id}`, { data });
}

export function deleteTimeMaterialBoard(id: string) {
  return Endpoint.delete<void>(`@gc/tm-change-order-board/${id}`);
}
